var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbox3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 291,
    viewBox: "0 0 618 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_257_238",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3972 0C10.923 0 0 10.923 0 24.3972V266.603C0 280.077 10.9231 291 24.3973 291H562.728C571.159 291 578.59 286.724 582.972 280.222H617.243L596.575 254.625L587.124 242.19V24.3955C587.124 10.9222 576.201 0 562.728 0H24.3972Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3972 0C10.923 0 0 10.923 0 24.3972V266.603C0 280.077 10.9231 291 24.3973 291H562.728C571.159 291 578.59 286.724 582.972 280.222H617.243L596.575 254.625L587.124 242.19V24.3955C587.124 10.9222 576.201 0 562.728 0H24.3972Z",
    fill: "#D9D9D9",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M582.972 280.222V279.781H582.738L582.607 279.976L582.972 280.222ZM617.243 280.222V280.663H618.166L617.586 279.945L617.243 280.222ZM596.575 254.625L596.224 254.892L596.232 254.902L596.575 254.625ZM587.124 242.19H586.683V242.338L586.773 242.456L587.124 242.19ZM0.440777 24.3972C0.440777 11.1664 11.1664 0.440777 24.3972 0.440777V-0.440777C10.6796 -0.440777 -0.440777 10.6796 -0.440777 24.3972H0.440777ZM0.440777 266.603V24.3972H-0.440777V266.603H0.440777ZM24.3973 290.559C11.1665 290.559 0.440777 279.834 0.440777 266.603H-0.440777C-0.440777 280.32 10.6796 291.441 24.3973 291.441V290.559ZM562.728 290.559H24.3973V291.441H562.728V290.559ZM582.607 279.976C578.303 286.361 571.006 290.559 562.728 290.559V291.441C571.311 291.441 578.877 287.087 583.338 280.469L582.607 279.976ZM617.243 279.781H582.972V280.663H617.243V279.781ZM596.232 254.902L616.9 280.499L617.586 279.945L596.918 254.348L596.232 254.902ZM586.773 242.456L596.224 254.892L596.926 254.358L587.475 241.923L586.773 242.456ZM586.683 24.3955V242.19H587.565V24.3955H586.683ZM562.728 0.440777C575.958 0.440777 586.683 11.1657 586.683 24.3955H587.565C587.565 10.6788 576.445 -0.440777 562.728 -0.440777V0.440777ZM24.3972 0.440777H562.728V-0.440777H24.3972V0.440777Z",
    fill: "#040D12",
    mask: "url(#path-1-inside-1_257_238)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbox3);
export default __webpack_public_path__ + "static/media/chatbox3.638af378ecc9fa1a640862c93194364c.svg";
export { ForwardRef as ReactComponent };